import { useMutation, useQuery } from '@apollo/react-hooks';
import { AppBar, Toolbar, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useSnackbar } from 'notistack';
import React, { useContext } from 'react';
import preval from 'preval.macro';
import { DispatchContext } from '../../App';
import Avatar from '../../components/Avatar';
import { USER_DETAILS, USER_CONFIGURATION_SETTINGS, GET_CONFIGURATION_SETTINGS } from '../graphQL/queries';
import UserSettings from './settings';
declare global {
  interface Window {
    ENVIRONMENT: any;
    REACT_LOGIN_URL: any;
    REACT_LOGOUT_URL: any;
  }
}

const useStyles = makeStyles(theme => ({
  root: {
    '& > * + *': {
      marginTop: theme.spacing(1)
    }
  },
  link: {
    color: 'inherit',
    textDecoration: 'none'
  }
}));

const UserProfile = () => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const [settingsDialogOpen, setSettingsDialogOpen] = React.useState<any>(false);
  const dispatch = useContext(DispatchContext);

  const { loading, data, refetch } = useQuery(USER_DETAILS, {});
  const [userConfigurationSettings] = useMutation(USER_CONFIGURATION_SETTINGS);
  const { loading: configurationLoading, data: configurationData, refetch: configurationRefetch } = useQuery(
    GET_CONFIGURATION_SETTINGS,
    {
      variables: { applicationId: 'BYN-SelfService', keys: ['global-global-settings-error-diagnosis'] }
    }
  );

  const handleLogout = () => {
    window.location.href = window.REACT_LOGOUT_URL;
  };

  const handleSettings = () => {
    setSettingsDialogOpen(true);
  };

  const userMenuItems = [
    {
      menuListHeader: 'logout',
      id: 'navbar-logout',
      onHeaderClick: handleLogout
    },
    {
      menuListHeader: 'settings',
      id: 'navbar-settings',
      onHeaderClick: handleSettings
    }
  ];

  const handleSaveSettings = (obj: any) => {
    // profileSave({
    //   variables: {
    //     userName: data?.userProfile?.userName,
    //     preferences: { ...data.userProfile?.userInfo?.preferences, ...obj }
    //   }
    // })
    //   .then(response1 => {
    //     enqueueSnackbar('User settings have been saved successfully !!', {
    //       variant: 'success',
    //       preventDuplicate: true
    //     });
    //     dispatch({
    //       type: 'userPreferences',
    //       data: {
    //         ...obj
    //       }
    //     });
    //     return response1;
    //   })
    //   .catch(error => {
    //     enqueueSnackbar('Unable to save user settings', { variant: 'error', preventDuplicate: true });
    //   });

    userConfigurationSettings({
      variables: {
        applicationId: 'BYN-SelfService',
        key: 'global-global-settings-error-diagnosis',
        hierarchy: 'USER',
        configuration: { ...obj }
      }
    })
      .then(response1 => {
        configurationRefetch();
        enqueueSnackbar('User settings have been saved successfully !!', {
          variant: 'success',
          preventDuplicate: true
        });
        dispatch({
          type: 'userPreferences',
          data: {
            ...obj
          }
        });
        return response1;
      })
      .catch(error => {
        enqueueSnackbar('Unable to save user settings', { variant: 'error', preventDuplicate: true });
      });
    setSettingsDialogOpen(false);
  };

  const handleCancel = () => {
    setSettingsDialogOpen(false);
  };

  return (
    <AppBar position="static" color="primary">
      <UserSettings
        settingsDialogOpen={settingsDialogOpen}
        handleCancel={handleCancel}
        handleSaveSettings={handleSaveSettings}
        data={configurationData}
      />
      <Toolbar variant="dense" className={classes.root}>
        {window.ENVIRONMENT && <span>{window.ENVIRONMENT}</span>}
        {loading ? (
          ''
        ) : (
          <>
            <Typography
              className={classes.link}
            >{`v${preval`module.exports =new Date().toISOString().split('T')[0];`}`}</Typography>
            <Avatar
              data-id="UserProfile-Icon"
              username={data?.userProfile?.userName || ''}
              menuItems={userMenuItems}
              paperProps={{ style: { transform: 'translateY(20px)' } }}
              id="navbar-user-avatar"
            />
          </>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default UserProfile;
